import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Button, Typography } from '@material-ui/core';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class AuthorizationClients extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Typography>
            Contain a list of Flybits clients able to submit data on your behalf
            <Button color="primary" onClick={this.props.handleAuthorize}>Core Data Submission</Button>
        </Typography>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(AuthorizationClients)));



// WEBPACK FOOTER //
// ./src/sub-projects/tenant/components/authorized-clients.tsx